// extracted by mini-css-extract-plugin
export default {"container":"StatusPanelMapControl_container__q9Bfr","halfScreenContainer":"StatusPanelMapControl_halfScreenContainer__pGSXF","iosZoning":"StatusPanelMapControl_iosZoning__qzG-u"};